import React from "react";
import { useChatSidebar } from "@src/features/aiAssist/hooks/useChatSidebar";
import { AiChatType, Ff } from "@src/types.generated";
import { useFeatureFlag } from "@src/features/app/hooks/useFeatureFlag";
import { Button } from "@src/lib/ui/Button";
import AskOpusOrbIcon from "@src/features/assistantChat/AskOpusOrbIcon";

export const AskOpusButton: React.FC = () => {
  const chatEnabled = useFeatureFlag(Ff.ChatKnowledgeBase);
  const { isOpen, toggle } = useChatSidebar(AiChatType.KnowledgeBase);

  if (!chatEnabled) return null;
  if (isOpen) return null;

  return (
    <Button
      variant="ghost"
      size="md"
      onClick={toggle}
      aria-pressed={isOpen}
      aria-label="Open Ask Opus"
      className="gap-1.5 pr-2 pl-1"
    >
      <AskOpusOrbIcon size={20} still />
      Ask Opus
    </Button>
  );
};

export default AskOpusButton;
